namespace h5_vm {

   export enum WorkgroupDomainTypeOption {
      WORKGROUP = 1,
      DOMAIN = 2
   }

}
